import { CloseRounded } from '@mui/icons-material';
import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react'
import { black, greyEnabled, purple, purpleLight } from '../../../../theme/colors';

export default function FilterUploadFile({
    openModal,
    setOpenModal,
    resetFilter,
    endDate,
    setEndDate,
    setStartDate,
    setStatus,
    statusList,
    startDate,
    status
}: {
    openModal: boolean;
    setOpenModal: (val: boolean) => void;
    resetFilter: () => void;
    startDate: string;
    endDate: string;
    setEndDate: (value: string) => void;
    setStartDate: (val: string) => void;
    setStatus: (val: number | null) => void;
    statusList: { id: number, value: string }[];
    status: number | null;
}) {
    const [_endDate, _setEndDate] = useState<string>(endDate);
    const [_startDate, _setStartDate] = useState<string>(startDate);
    const [_status, _setStatus] = useState<number | null>(status);

    const handleClose = () => setOpenModal(false);

    return (
        <Dialog open={openModal} onClose={handleClose} PaperProps={{ sx: { borderRadius: 4 } }}>
            <Box sx={{ width: 420, maxWidth: "90vw" }}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ px: 3, pt: 2.5, pb: 1.5, borderBottom: "1px solid #ECECEC" }}
                >
                    <Typography variant="h6" fontWeight={700} color={black}>
                        Filter Files
                    </Typography>
                    <IconButton onClick={handleClose} size="small">
                        <CloseRounded sx={{ color: greyEnabled }} />
                    </IconButton>
                </Box>

                <Box sx={{ px: 3, pt: 2.5, pb: 3, maxHeight: 480, overflow: "auto" }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" fontWeight={600} color={black}>
                            Date Range
                        </Typography>
                        <Button
                            variant="text"
                            sx={{ p: 0, minWidth: "auto", color: purple, textTransform: "none", fontWeight: 600 }}
                            onClick={() => {
                                _setStartDate("");
                                _setEndDate("");
                                _setStatus(null);
                            }}
                        >
                            Reset
                        </Button>
                    </Box>
                    <Box pt={2} pb={1} display="flex" flexDirection={"column"} gap={2}>
                        <DatePicker
                            label="From Date"
                            format="DD-MM-YYYY"
                            disableFuture
                            value={_startDate ? dayjs(_startDate, "YYYY-MM-DD") : null}
                            onChange={(value: Dayjs | null) => {
                                _setStartDate(value?.format("YYYY-MM-DD") || "");
                            }}
                            slotProps={{ desktopPaper: { elevation: 0, sx: { borderRadius: 2, border: "1px solid #ECECEC", boxShadow: "0px 12px 28px -8px rgba(27, 0, 27, 0.18)" } } }}
                            sx={{ "& .MuiSvgIcon-root": { fill: purple } }}
                        />
                        <DatePicker
                            label="To Date"
                            format="DD-MM-YYYY"
                            disableFuture
                            value={_endDate ? dayjs(_endDate, "YYYY-MM-DD") : null}
                            onChange={(value: Dayjs | null) => {
                                _setEndDate(value?.format("YYYY-MM-DD") || "");
                            }}
                            slotProps={{ desktopPaper: { elevation: 0, sx: { borderRadius: 2, border: "1px solid #ECECEC", boxShadow: "0px 12px 28px -8px rgba(27, 0, 27, 0.18)" } } }}
                            sx={{ "& .MuiSvgIcon-root": { fill: purple } }}
                        />
                    </Box>

                    <Typography variant="body2" fontWeight={600} color={black} mt={2} mb={1}>
                        Status
                    </Typography>
                    <Box display="flex" flexWrap={"wrap"} gap={1}>
                        {statusList?.map((item) => (
                            <Button
                                key={item.id}
                                onClick={() => _setStatus(item?.id)}
                                variant={_status === item?.id ? "contained" : "outlined"}
                                disableElevation
                                sx={_status === item?.id ? {
                                    bgcolor: purple,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": { bgcolor: "#7A2074" },
                                } : {
                                    borderColor: purple,
                                    color: purple,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": { borderColor: purple, bgcolor: purpleLight },
                                }}
                            >
                                {item?.value}
                            </Button>
                        ))}
                    </Box>

                    <Box display="flex" gap={1.5} mt={4}>
                        <Button
                            fullWidth
                            onClick={() => {
                                resetFilter();
                                setOpenModal(false);
                            }}
                            variant="outlined"
                            sx={{
                                borderColor: purple,
                                color: purple,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                "&:hover": { borderColor: purple, bgcolor: purpleLight },
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            fullWidth
                            variant="contained"
                            disableElevation
                            onClick={() => {
                                setStatus(_status);
                                setStartDate(_startDate);
                                setEndDate(_endDate);
                                setOpenModal(false);
                            }}
                            sx={{
                                bgcolor: purple,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                "&:hover": { bgcolor: "#7A2074" },
                            }}
                        >
                            Apply Filters
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    )
}
